import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'
import Select from 'react-select'
import chroma from 'chroma-js'

const tableStyle = {
  backgroundColor: '#ffffff',
  marginBottom: '50px',
}

const tbodyStyle = {
  display: 'block',
  maxHeight: '400px',
  overflowY: 'scroll',
}

const colourStyles = {
  control: styles => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = chroma(data.value)
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
          ? data.value
          : isFocused
            ? color.alpha(0.1).css()
            : null,
      color: isDisabled
        ? '#ccc'
        : isSelected
          ? chroma.contrast(color, 'white') > 2
            ? 'white'
            : 'black'
          : data.value,
      cursor: isDisabled ? 'not-allowed' : 'default',

      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? data.value : color.alpha(0.3).css()),
      },
    }
  },
  input: styles => ({ ...styles, ...dot() }),
  placeholder: styles => ({ ...styles, ...dot() }),
  singleValue: (styles, { data }) => ({ ...styles, ...dot(data.value) }),
}

const dot = (color = '#ccc') => ({
  alignItems: 'center',
  display: 'flex',

  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    content: '" "',
    display: 'block',
    marginRight: 8,
    height: 10,
    width: 10,
  },
})

class LegendOncall extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      options: props.oncall.teams,
    }
  }

  renderHeader() {
    return <Fragment><th key="legend" colSpan="2" style={{borderTopWidth: '0px'}}><h3>Legend</h3></th></Fragment>
  }

  renderData() {
    const myData = [].concat(Object.values(this.props.oncall.colors))
    return Object.keys(myData).map((key) => {
      const color = myData[key]
      return <tr key={key}><td>{color['description']}</td><td><div className="col-sm-6 bd-placeholder-img rounded" style={{backgroundColor: color['name'], height: '32px', width: '92px', display: 'inline-block'}}></div></td></tr>
    }
    )
  }

  render() {
    if (this.props.oncall.colors) {
      return <div className="row"><table className="table" style={tableStyle}><tbody style={tbodyStyle}><tr>{this.renderHeader()}</tr>{this.renderData()}</tbody></table><Select id="myteams" name="teams" className="col-md-10" options={this.state.options} styles={colourStyles} placeholder={'Teams'} onChange={(se) => window.location.href = '/teams/' + se.id.toString()}></Select></div>
    }
    return <div>Waiting</div>
  }
}

LegendOncall.propTypes = {
  oncall: PropTypes.object,
}

export default LegendOncall
